import React, { useRef, useState, useEffect } from 'react';
import ReactDatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';
import { useField } from '@unform/core';
import 'react-datepicker/dist/react-datepicker.css';
import { parseISO } from 'date-fns';
import pt from 'date-fns/locale/pt-BR';
import { Container } from './styles';

registerLocale('pt', pt);

interface IProps extends Omit<ReactDatePickerProps, 'onChange'> {
  name: string;
  placeholder ?: string;
}
const DatePicker: React.FC<IProps> = ({ name, placeholder, ...rest }) => {
  const datepickerRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);
  const [date, setDate] = useState(
    defaultValue ? parseISO(defaultValue) : null,
  );
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: datepickerRef.current,
      path: 'props.selected',
      clearValue: (ref: any) => {
        ref.clear();
      },
    });
  }, [fieldName, registerField]);
  return (
    <Container isFocused={false} isErrored={false} isFilled={false}>
      <span>{placeholder}</span>
      <ReactDatePicker
        locale="pt"
        dateFormat="HH:mm"
        ref={datepickerRef}
        selected={date}
        onChange={setDate}
        showTimeSelect
        showTimeSelectOnly
    timeFormat="HH:mm"
    timeIntervals={15}
 
        {...rest}
      />
    </Container>
  );
};
export default DatePicker;
